// extracted by mini-css-extract-plugin
export default {"mainSection":"Adminmanagecourses_mainSection__sCna8","error-message":"Adminmanagecourses_error-message__I26jG","center":"Adminmanagecourses_center__bn28N"};